export const initialUserProfileForm = {
  name: '',
  lastname: '',
  company: '',
};
